import { Reveal } from '../components/Reveal'
import { FluidHeading } from '../components/FluidHeading'
import { SmoothAnchor } from '../components/SmoothAnchor'

export function CTA() {
  return (
    <section className="relative mx-auto max-w-6xl px-5 py-10 sm:px-8">
      <Reveal>
        <div className="glow-border relative overflow-hidden rounded-[2rem] bg-gradient-to-br from-orb-600 via-orb-800 to-space-900 px-6 py-20 text-center sm:px-16 sm:py-24">
          <div className="pointer-events-none absolute inset-0 tech-grid opacity-30" />
          <div
            className="pointer-events-none absolute inset-0 opacity-60"
            style={{ background: 'radial-gradient(circle at 50% 0%, rgba(200,160,255,0.35), transparent 60%)' }}
          />
          <div
            className="pointer-events-none absolute inset-0 opacity-40"
            style={{ background: 'radial-gradient(circle at 50% 100%, rgba(139,60,240,0.4), transparent 55%)' }}
          />
          <div className="relative">
            <FluidHeading as="h2" className="mx-auto max-w-xl text-3xl font-semibold text-white sm:text-5xl">
              Vamos descobrir até onde seu negócio pode chegar?
            </FluidHeading>
            <p className="mx-auto mt-4 max-w-md text-white/70">
              Estratégia, performance e criação trabalhando em torno do que realmente importa: resultado.
            </p>
            <SmoothAnchor
              href="#contato"
              className="mt-9 inline-block rounded-full bg-white px-9 py-4 text-sm font-semibold text-space-950 shadow-[0_0_40px_-10px_rgba(255,255,255,0.6)] transition-transform hover:scale-105"
            >
              Falar com a Orb
            </SmoothAnchor>
          </div>
        </div>
      </Reveal>
    </section>
  )
}
